export const PHOTO_NAMES = {
  amalfi: 'Amalfi coast',
  alpine: 'Alpine lake',
  kyoto: 'Kyoto evening',
  pottery: 'Pottery studio',
};
// Owns curated reel presentation presets; domain policy owns valid media options.
export const REEL_PACKS = [
  {
    id: 'weekend',
    name: 'Weekend escape',
    emoji: '🧳',
    title: 'A weekend worth keeping',
    filter: 'vivid',
    music: 'coastal-pulse',
    seconds: 2.5,
    prompts: ['The arrival', 'A favorite detail', 'The best moment', 'One last look'],
  },
  {
    id: 'vacation',
    name: 'Vacation postcard',
    emoji: '🏝️',
    title: 'Wish you were here',
    filter: 'warm',
    music: 'open-sky',
    seconds: 3,
    prompts: ['The destination', 'The view', 'A hidden gem', 'Golden hour'],
  },
  {
    id: 'night-out',
    name: 'Night out',
    emoji: '🌃',
    title: 'One unforgettable night',
    filter: 'cinema',
    music: 'coastal-pulse',
    seconds: 1.5,
    prompts: ['Getting ready', 'The entrance', 'The energy', 'The way home'],
  },
  {
    id: 'date-night',
    name: 'Restaurant date',
    emoji: '🍽️',
    title: 'A table for two',
    filter: 'warm',
    music: 'quiet-morning',
    seconds: 3,
    prompts: ['The setting', 'First bite', 'The favorite dish', 'The verdict'],
  },
  {
    id: 'city-guide',
    name: 'Mini city guide',
    emoji: '📍',
    title: 'A few places to keep',
    filter: 'vivid',
    music: 'open-sky',
    seconds: 2.5,
    prompts: ['Start here', 'A local favorite', 'Something unexpected', 'Save this stop'],
  },
  {
    id: 'day-life',
    name: 'Day in my life',
    emoji: '☀️',
    title: 'The little things today',
    filter: 'original',
    music: 'quiet-morning',
    seconds: 2,
    prompts: ['Morning ritual', 'Out and about', 'A small win', 'Evening reset'],
  },
  {
    id: 'before-after',
    name: 'Before & after',
    emoji: '✨',
    title: 'From this to this',
    filter: 'vivid',
    music: 'coastal-pulse',
    seconds: 3,
    prompts: ['Before', 'The process', 'The reveal', 'The detail'],
  },
  {
    id: 'how-to',
    name: 'Quick how-to',
    emoji: '🛠️',
    title: 'Here’s how I do it',
    filter: 'original',
    music: 'none',
    seconds: 3,
    prompts: ['What you’ll need', 'Step one', 'Step two', 'The result'],
  },
  {
    id: 'favorites',
    name: 'Three favorites',
    emoji: '💎',
    title: 'Three things I keep coming back to',
    filter: 'cinema',
    music: 'open-sky',
    seconds: 2.5,
    prompts: ['My first pick', 'My second pick', 'My third pick', 'Why I love them'],
  },
  {
    id: 'community',
    name: 'People & purpose',
    emoji: '🤝',
    title: 'Small moments. Shared purpose.',
    filter: 'warm',
    music: 'quiet-morning',
    seconds: 3,
    prompts: ['The people', 'The purpose', 'Taking action', 'Join the conversation'],
  },
];
